// src/adminComponent/ViewAllSuppliers.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import "../css/ViewAllCustomers.css"; // reuse the same CSS file
import { FaSearch } from "react-icons/fa";

const ViewAllSuppliers = () => {
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const admin_jwtToken = sessionStorage.getItem("admin-jwtToken");

  useEffect(() => {
    const getAllUsers = async () => {
      const allUsers = await retrieveAllUser();
      if (allUsers && Array.isArray(allUsers.users)) {
        setAllSuppliers(allUsers.users);
        setFiltered(allUsers.users);
      } else {
        setAllSuppliers([]);
        setFiltered([]);
      }
      setLoading(false);
    };

    getAllUsers();
  }, []);

  const retrieveAllUser = async () => {
    try {
      const response = await axios.get(
        "https://goldenhides.in/api/user/fetch/role-wise?role=Supplier",
        {
          // headers: { Authorization: "Bearer " + admin_jwtToken }
        }
      );
      return response.data;
    } catch (err) {
      console.error("fetch suppliers error", err);
      setLoading(false);
      return null;
    }
  };

  // search logic
  useEffect(() => {
    const term = (q || "").trim().toLowerCase();
    if (!term) {
      setFiltered(allSuppliers);
      return;
    }
    const out = allSuppliers.filter((s) => {
      const name = `${s.firstName || ""} ${s.lastName || ""}`.toLowerCase();
      const email = (s.emailId || "").toLowerCase();
      const phone = String(s.phoneNo || "");
      const addr =
        s.address && (s.address.street || s.address.city || s.address.pincode)
          ? `${s.address.street || ""} ${s.address.city || ""} ${
              s.address.pincode || ""
            }`.toLowerCase()
          : "";
      return (
        name.includes(term) ||
        email.includes(term) ||
        phone.includes(term) ||
        addr.includes(term)
      );
    });
    setFiltered(out);
  }, [q, allSuppliers]);

  return (
    <div className="mt-3">
      <div className="container">
        <div className="card form-card custom-bg shadow-lg customers-card">
          <div className="card-header d-flex align-items-center justify-content-between bg-color custom-bg-text">
            <div>
              <h3 className="mb-0">All Suppliers</h3>
              <small className="text-muted">Manage registered suppliers</small>
            </div>

            <div className="d-flex align-items-center gap-2">
              <div className="search-input-wrapper">
                <FaSearch className="search-icon" />
                <input
                  type="search"
                  placeholder="Search name, email, phone or address"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  className="form-control small search-input"
                />
              </div>
            </div>
          </div>

          <div className="card-body" style={{ minHeight: "20rem" }}>
            {loading ? (
              <div className="text-center py-5 text-muted">
                Loading suppliers...
              </div>
            ) : filtered.length === 0 ? (
              <div className="text-center py-5 text-muted">
                No suppliers found.
              </div>
            ) : (
              <div className="customers-grid">
                {filtered.map((supplier) => {
                  const addressText = supplier.address
                    ? `${supplier.address.street || ""}, ${
                        supplier.address.city || ""
                      } ${
                        supplier.address.pincode
                          ? "- " + supplier.address.pincode
                          : ""
                      }`
                    : null;

                  return (
                    <article
                      className="customer-card"
                      key={supplier.id || supplier.emailId}
                    >
                      <header className="customer-card-head">
                        <div className="avatar-circle">
                          {supplier.firstName || supplier.lastName ? (
                            <span className="avatar-initials">
                              {(supplier.firstName || "S")
                                .charAt(0)
                                .toUpperCase()}
                              {(supplier.lastName || "")
                                .charAt(0)
                                .toUpperCase()}
                            </span>
                          ) : (
                            <span className="avatar-initials">S</span>
                          )}
                        </div>

                        <div className="customer-meta">
                          <div className="customer-name">
                            {supplier.firstName} {supplier.lastName}
                          </div>
                          <div className="customer-email small text-muted">
                            {supplier.emailId}
                          </div>
                        </div>

                        <div className="customer-badge small text-muted">
                          {supplier.role || "Supplier"}
                        </div>
                      </header>

                      <div className="customer-body">
                        <div className="info-row">
                          <div className="label">Phone</div>
                          <div className="value">{supplier.phoneNo || "-"}</div>
                        </div>

                        <div className="info-row mt-2">
                          <div className="label">Address</div>
                          <div className="value address-muted">
                            {addressText || (
                              <span className="text-muted">No address</span>
                            )}
                          </div>
                        </div>
                      </div>

                      <footer className="customer-card-footer">
                        <div className="small text-muted">
                          Joined:{" "}
                          {supplier.createdAt
                            ? new Date(
                                Number(supplier.createdAt)
                              ).toLocaleDateString()
                            : "-"}
                        </div>
                        <div className="card-actions">
                          <button className="btn btn-sm btn-outline-secondary">
                            View
                          </button>
                        </div>
                      </footer>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllSuppliers;
